import txcbApi from "apis/txcb-api";
import { RootState, useAppSelector } from "cache/store";
import { ChatItemTXCB, ParamBetTXCB, PayloadBodyTopicTXCB, PayloadBodyUserQueueTXCB } from "models/txcb-model";
import { useEffect, useRef, useState } from "react";
import txcbSocket from "socket/txcb";
import BoardTXCB from "./board-txcb/board-txcb";
import BoxChatMinigame from "components/BoxChatMinigame/box-chat-minigame";
import Modal from "components/modal/Modal";
import { chatSuggestTXCB } from "./txcb-function";
import './txcb.scss';
import LSCMiniGame from "./lsc/lsc";
import LSPMiniGame from "./lsp/lsp";
import HDMiniGame from "./hd/hd";
import MiniRank from "../bxh/bxh";

interface Props {
    onClose: () => void;
    onChangeMsg: (inputData: string) => void;
  }
  
export default function TXCB(props: Props) {
    const { onClose, onChangeMsg } = props;

    const maintainTXCB = useRef(false);
    const hisPhienData = useRef<{ id: string; result: number[] }[]>([]);
    const { stompTXCB } = useAppSelector((state: RootState) => state.socket);
    const { userInfo } = useAppSelector((state: RootState) => state.auth);

    const [TXCBTopicData, setTXCBTopicData] = useState({} as PayloadBodyTopicTXCB);
    const [TXCBUserQueueData, setTXCBUserQueueData] = useState({} as PayloadBodyUserQueueTXCB);

    const [showRank, setShowRank] = useState(false);
    const [rankData, setRankData] = useState<any[]>([]);

    const [showHisPhien, setShowHisPhien] = useState(false);

    const [showHistoryMyBet, setShowHistoryMyBet] = useState(false);

    const [showHelp, setShowHelp] = useState(false);

    const [showChat, setShowChat] = useState(false);
    const [chatList, setChatList] = useState<ChatItemTXCB[]>([]);

    const handleGetMsg = (msg: any) => {
        onChangeMsg(msg);
    };

    useEffect(() => {
        if (stompTXCB) {
            stompTXCB.subscribe('/topic/tx', (data: { body: string }) => {
                const body: PayloadBodyTopicTXCB = JSON.parse(data.body);
                if (body.cmd === 12 && body.rs) {
                    maintainTXCB.current = true;
                }

                //chat response
                if (body.cmd === 10) {
                    setChatList((list) => [...list, body as any]);
                }
                setTXCBTopicData(body);
            });

            stompTXCB.subscribe('/user/queue/tx', (data: any) => {
                const body: PayloadBodyUserQueueTXCB = JSON.parse(data.body);
                setTXCBUserQueueData(body);

                //chat
                if (body.cmd === 11) {
                    setChatList(body.data as any[]);
                }
            });

            setTimeout(() => {
                subscribeLSP('/topic/lichsuphien');
                subscribeLSP('/topic/public');
            }, 150);
        }
    }, [stompTXCB]);

    const subscribeLSP = (topic: string) => {
        txcbSocket.sendMessage(topic, {});
    };

    const submitBet = (topic: string, payload: ParamBetTXCB) => {
        if (stompTXCB && stompTXCB.connected) {
            payload = { ...payload, userId: userInfo.id, loginname: userInfo.loginname, userType: userInfo.usertype };
            txcbSocket.sendMessage(topic, payload);
        }
    };

    const getRank = async () => {
        setShowRank(true);
        try {
            const { data } = await txcbApi.getRank();
            const topTen = (data as any)
                .filter((item: any) => item.amount && item.amount > 0)
                .sort((a: any, b: any) => b['amount'] - a['amount'])
                .slice(0, 10);
            setRankData(topTen);
        } catch (error) {
            console.log(error);
        }
    };

    const sendChat = (msg: string, cb: () => void) => {
        if (Number(userInfo.balance) < 20000) {
            handleGetMsg('Số dư của bạn phải trên 20,000 để có thể chat!');
            return;
        }
        const payload = {
            u: userInfo.loginname,
            m: msg,
        };
        txcbSocket.sendMessage('/topic/chats', payload);
    };

    return (
        <div className="txcb-page-wrap">
            <div className="txcb-page">
                <div className="board-game">
                    <div className="btn-header-list">
                        <div className="btn-group">
                            <button className="btn-reset" onClick={getRank}>
                                <img src={require(`assets/images/txcanban/btn-rank.png`)} alt="" />
                            </button>
                            <button className="btn-reset" onClick={() => setShowHisPhien(true)}>
                                <img src={require(`assets/images/txcanban/btn-tk-phien.png`)} alt="" />
                            </button>
                            <button className="btn-reset" onClick={() => setShowHistoryMyBet(true)}>
                                <img src={require(`assets/images/txcanban/btn-his-bet.png`)} alt="" />
                            </button>
                        </div>
                        <div className="btn-group">
                            <button className="btn-reset" onClick={() => setShowHelp(true)}>
                                <img src={require(`assets/images/txcanban/btn-help.png`)} alt="" />
                            </button>
                            <button className="btn-reset" onClick={() => setShowChat(!showChat)}>
                                {!showChat ? (
                                    <img src={require(`assets/images/icons/chat-off.png`)} alt="" />
                                ) : (
                                    <img src={require(`assets/images/icons/chat-on.png`)} alt="" />
                                )}
                            </button>
                            <button className="btn-reset" onClick={onClose}>
                                <img src={require(`assets/images/txcanban/btn-close.png`)} alt="" />
                            </button>
                        </div>
                    </div>
                    <BoardTXCB
                        balance={userInfo.balance}
                        bodyTopic={TXCBTopicData}
                        userQueue={TXCBUserQueueData}
                        onBet={submitBet}
                        lspData={hisPhienData.current}
                        onUpdatePhien={(value) => (hisPhienData.current = value)}
                        onChangeMsg={handleGetMsg}
                    />

                </div>

                <div className={`chat-box ${showChat ? 'show' : ''}`}>
                    <BoxChatMinigame
                        chatList={showChat ? chatList : []}
                        chatSuggest={chatSuggestTXCB}
                        onSend={sendChat}
                        onClose={() => setShowChat(false)}
                    />
                </div>
            </div>
            {/* bảng xếp hạng */}
            <Modal isShow={showRank} onClose={() => setShowRank(false)} width="920px">
                <MiniRank rankList={rankData} onClose={() => setShowRank(false)} />
            </Modal>

            <Modal isShow={showHelp} onClose={() => setShowHelp(false)} width="920px">
                <HDMiniGame onClose={() => setShowHelp(false)} />
            </Modal>

            <Modal isShow={showHistoryMyBet} onClose={() => setShowHistoryMyBet(false)} width="920px">
                <LSCMiniGame onClose={() => setShowHistoryMyBet(false)} />
            </Modal>

            <Modal isShow={showHisPhien} onClose={() => setShowHisPhien(false)} width="920px">
                <LSPMiniGame wsData={hisPhienData.current} onClose={() => setShowHisPhien(false)} />
            </Modal>
        </div>
    );
}
